import React from "react";
import { CookiesProvider } from "react-cookie";
import { CartProvider } from "../context/cartContext";
import { UserProvider } from "../context/userContext";
import { FoodTypeProvider } from "../context/foodTypeContext";
import { DeliveryOptionProvider } from "../context/deliveryOptionContext";

const MainProvider = (props) => {
  return (
    <CookiesProvider>
      <UserProvider>
        <DeliveryOptionProvider>
          <FoodTypeProvider>
            <CartProvider>{props.children}</CartProvider>
          </FoodTypeProvider>
        </DeliveryOptionProvider>
      </UserProvider>
    </CookiesProvider>
  );
};

export default MainProvider;
